// extracted by mini-css-extract-plugin
export default {"debug":"CreateReminder_debug__DweDg","link":"CreateReminder_link__sHd6Y"};